module.exports = __webpack_public_path__ + "img/step45.b093a054.png";